<template>
    <el-container direction="vertical" class="card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка контакта
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="save" v-if="canEdit">
                    {{ saveBtnText }}
                </span>
                <span class="action-title action-close" @click="close">
                    Отменить
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start" class="card-general ml16">
                <el-form :model="contact" label-position="top">
                    <el-row>
                        <el-col :span="24" justify="start">
                            <div class="input-label">
                                Имя
                            </div>
                            <div :class="{ 'error-input': errors.name }">
                                <el-input v-model="contact.name" size="mini" autocomplete="off" />
                                <div class="error" v-if="errors.name">
                                    {{ errors.name[0] }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="task-item-row row phones">
                        <div class="input-label">
                            Телефон
                        </div>
                        <template v-for="(contactPhone, index) in contact.contact_phones">
                            <div :key="index" class="tel-item">
                                <el-col :span="20" :class="['mb10', { 'error-input': errors.phone }]">
                                    <div class="el-input el-input--mini">
                                        <the-mask
                                            v-model="contactPhone.phone"
                                            mask="+# (###) ###-##-##"
                                            placeholder="+7 (495) 123-45-67"
                                            class="el-input__inner"
                                        />
                                    </div>
                                </el-col>
                                <el-col :span="2" class="icon-phone">
                                    <div class="pt5 pl5 pointer" @click="calltoPhone(contactPhone.phone)">
                                        <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                                    </div>
                                </el-col>
                                <el-col :span="2" v-if="!isMain(contactPhone)" class="icon-delete">
                                    <div class="delete-phone" @click="deletePhone(index, contactPhone)">
                                        <i class="el-icon-close"></i>
                                    </div>
                                </el-col>
                            </div>
                            <template>
                                <div class="field-error" v-if="errors[`contact_phones.${index}.phone`]" :key="index+'error'">
                                    {{ errors[`contact_phones.${index}.phone`][0] }}
                                </div>
                            </template>
                        </template>
                        <div class="ml0">
                            <el-col>
                                <el-button class="button-icon" size="mini" @click="addNewPhone">
                                    <font-awesome-icon icon="plus" class="orange" />
                                </el-button>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.email }">
                            <div class="input-label">
                                E-mail
                            </div>
                            <el-input size="mini" autocomplete="off" v-model="contact.email" />
                            <div class="error" v-if="errors.email">
                                {{ errors.email[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.birthday }">
                            <div class="input-label">
                                День рождения
                            </div>
                            <el-date-picker
                                v-model="contact.birthday"
                                type="date"
                                placeholder="день.месяц.год"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="timestamp"
                                size="mini"
                                class="w100"
                                :picker-options="pickerOptions"
                            />
                            <div class="error" v-if="errors.birthday">
                                {{ errors.birthday[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.company_id }">
                            <div class="input-label">
                                Компания
                            </div>
                            <el-select
                                v-model="contact.company_id"
                                filterable
                                remote
                                reserve-keyword
                                size="mini"
                                placeholder="Введите название компании"
                                :remote-method="searchCompany"
                            >
                                <el-option
                                    v-for="item in companyOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.company_id">
                                {{ errors.company_id[0] }}
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="16" class="card-comment" :class="{ 'error-input': errors.comment }">
                <div class="input-label">
                    Комментарий
                </div>
                <el-input
                    size="mini"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder=""
                    v-model="contact.comment"
                />
                <div class="error" v-if="errors.comment">
                    {{ errors.comment[0] }}
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPlus, faPhone } from '@fortawesome/free-solid-svg-icons';
import '@/assets/styles/card.scss';
import { pickerOptions } from '@/common/pickerOptions';

library.add(faCheck, faPlus, faPhone);

export default {
    name: 'ContactsCardEdit',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            contact: {
                id: null,
                name: null,
                phone: null,
                email: null,
                address: null,
                birthday: null,
                company_id: null,
                contact_phones: []
            },
            companyOptions: [],
            loadingCompany: false,
            loading: true,
            errors: {},
            list: [],
            pickerOptions
        };
    },
    mounted() {
        setTimeout(() => {
            this.companyOptions = JSON.parse(JSON.stringify(this.companies));
        }, 1000);
    },
    async beforeMount() {
        if (!this.isNew) {
            await this.$store.dispatch('contacts/getContact', this.id).then(
                response => {
                    this.loading = false;
                    this.contact = response.data.data;
                },
                error => {
                    if (error.response.status !== 422) {
                        console.log(error.response.data.error);
                        this.loading = false;
                        this.$router.go(-1);
                    }
                    console.log(error);
                }
            );
        } else {
            if (this.$route.params.companyId) {
                this.contact.company_id = +this.$route.params.companyId;
            }
            this.loading = false;
        }
    },
    computed: {
        companies() {
            return this.$store.state.references.companies;
        },
        isNew() {
            return +this.id === 0;
        },
        saveBtnText() {
            return +this.id === 0 ? ' Создать ' : 'Применить';
        },
        canEdit() {
            const approvedRoles = this.$store.getters['references/rolesBySectionContacts'];
            if (approvedRoles.indexOf('companies_read') !== -1) {
                approvedRoles.splice(approvedRoles.indexOf('companies_read'), 1);
            }
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));

            return intersection.length > 0;
        }
    },
    methods: {
        searchCompany(query) {
            if (query !== '') {
                this.companyOptions = this.companies.filter(
                    item => item.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
            } else {
                this.companyOptions = JSON.parse(JSON.stringify(this.companies));
            }
        },
        save() {
            this.loading = true;
            const action = this.isNew ? 'createContact' : 'updateContact';
            this.$store.dispatch('contacts/' + action, this.contact).then(
                response => {
                    this.loading = false;
                    if (response.data.success) {
                        this.$router.push({ name: 'contact-card', params: { id: '' + response.data.data.id } });
                    } else {
                        this.errors = response.data.data;
                    }
                },
                error => {
                    this.loading = false;
                    if (error.response.status !== 422) {
                        console.log(error.response.data.error);
                        this.loading = false;
                        this.$router.go(-1);
                    } else {
                        this.errors = error.response.data.errors;
                    }
                }
            ).finally(() => { this.loading = false; });
        },
        close() {
            if (this.isNew) {
                this.$router.go(-1);
            } else {
                this.$router.push({ name: 'contact-card', params: { id: '' + this.id } });
            }
        },
        isMain(contactPhone) {
            return contactPhone.is_main === 1;
        },
        deletePhone(index) {
            const phones = [...this.contact.contact_phones];
            phones.splice(index, 1);
            this.contact.contact_phones = [...phones];
        },
        addNewPhone() {
            const phone = {
                id: null,
                contact_id: this.contact.id,
                phone: null,
                is_main: 0
            };
            this.contact.contact_phones = [...this.contact.contact_phones, ...[phone]];
        },
        calltoPhone(phone) {
            this.loading = true;
            this.$store.dispatch('voip/callToPhone', { phone: phone }).then(
                response => {
                    console.log('response', response.data.data);
                    this.$message({
                        showClose: true,
                        message: 'Начат звонок на номер ' + phone,
                        type: 'success',
                        duration: 3000,
                        customClass: this.alertClass()
                    });
                    this.errors = {};
                },
                error => {
                    console.log('error', error.response.data);
                    this.$message({
                        showClose: true,
                        message: 'Ошибка при звоноке на номер ' + phone,
                        type: 'error',
                        duration: 1500,
                        customClass: this.alertClass()
                    });
                }
            ).finally(() => { this.loading = false; });
        }
    }
};
</script>
